import { Cancel, Close, Flight, Group, Luggage } from '@mui/icons-material'
import { Box, Button, MenuItem, Popover, TextField } from '@mui/material'
import { DatePicker } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
// import moment from 'moment/moment';
import { offerSearchTemp } from '../../data/flight/offerSearchData';
import moment from 'moment/moment';
import { decrypt, encrypt } from '../../features/utils/crypto';
import { clone } from '../../features/utils/objClone';
import { useDispatch, useSelector } from 'react-redux';
import { setBookingData } from '../../redux/reducers/flight/flightBookingSlice';
import TravelPassengers from '../flight/filters/TravelPassengers';
import TravelLuggage from '../flight/filters/TravelLuggage';
import IataInput from '../form/IataInput';
import AirlinesInput from '../form/AirlinesInput';
import { def } from '../../config';
import { FLIGHT_TYPES } from '../../data/ENUM/FlightTypes';
import { Icon } from '@iconify/react';
import { setAlertMsg } from '../../redux/reducers/modal/snackBarSlice';


const {RangePicker} = DatePicker;

export default function FlightSearchInput({cur,gotQ,newWindow}) {
  const [type,setType] = useState(cur || 1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {bookingData} = useSelector(state => state.flightBooking);
  const [passengers,setPassengers] = useState(offerSearchTemp.passengers);
  const [flightType,setFlightType] = useState('INTERNATIONAL');
  const [selectedCurrency,setSelectedCurrency] = useState(def.currencyCode||'')
  const [searchParam] = useSearchParams();
  const q = useMemo(() => searchParam.get('q'),[searchParam]);
  const [qObj,setQObj] = useState();

  const [noStops,setNoStops] = useState(qObj && qObj.noAirportChange)
  const [airline,setAirline] = useState();

  const [travelClass,setTravelClass] = useState((qObj && qObj.travelClass) || 'Economy');

  const [corporateUniFares,setCorporateUniFares] = useState("");

  const [hideBar,setHideBar] = useState(gotQ);

  // const [data,setData] = useState(offerSearchTemp);
  // console.log('rendering SearchINputs: ',qObj)
  // console.log('TC: ',travelClass)
  const handleSetPassengers = useCallback((newPassengers) => {
    setPassengers(newPassengers);
  }, []);

  useEffect(() => {
    if(q) {
      let obj = JSON.parse(decrypt(q));
      setQObj(obj)
      setSelectedCurrency(obj?.currencyOverride || selectedCurrency)
      setNoStops(obj && obj.noAirportChange)
      setTravelClass((obj && obj.travelClass) || 'Economy')
      setFlightType((obj?.flightType) || 'All')
      if(obj?.destinations?.length > 1) {
        let arrival = obj?.destinations?.at(-1)?.arrivalLocation;
        let destiny = obj?.destinations[0]?.departureLocation;
        
        if(destiny?.iata) destiny = destiny.iata;
        if(arrival?.iata) arrival = arrival.iata;

        if(arrival === destiny)
          setType(2)
        else setType(3)
      }
      // setType(obj?.destinations?.length || 1)
    }
  },[q])

  console.log(qObj,' ----------')

  function handleSearch(ev,dataInp) {
    ev.preventDefault();

    if(!(bookingData?.as || bookingData?.cwt || bookingData?.userType))
      return dispatch(setAlertMsg(['error','Please Select Chanel/Company']))

    let searchObj = dataInp;
    searchObj['passengers'] = passengers;
    searchObj['travelClass'] = travelClass;
    if(flightType !== 'Any') 
      searchObj['flightType'] = flightType;
    searchObj['requestedFlightTypes'] = noStops ? ['N'] : null;
    searchObj['airlineOptions'] = airline ? {
      "M": [airline]
    }:null
    if(corporateUniFares) {
      searchObj['corporateUniFares'] = corporateUniFares.split(",")
    }

    searchObj['destinations'] = searchObj?.destinations?.splice(0,type < 3 ? type : 100);
    
    let valid = searchObj['destinations']?.map((obj,i) => {
      let departure = obj?.departureLocation?.iata || obj?.departureLocation;
      let arrival = obj?.arrivalLocation?.iata || obj?.arrivalLocation;
      if(departure === arrival || !departure || !arrival)
        return false;

      // if(i > 0 && obj.departureLocation === searchObj['destinations'][i-1].departureLocation)

      return true;
    })
    if(valid.some(val => !val)) return dispatch(setAlertMsg(['error','Invalid Route! Please make sure of the locations.']))

    if(searchObj['destinations']?.some(obj => !obj.date))
      return dispatch(setAlertMsg(['error','Invalid Date! Please select a valid date']))
    // searchObj.destinations?.map(obj => {
    //   obj.departureLocation = obj.departureLocation?.iata || obj.departureLocation
    //   obj.arrivalLocation = obj.arrivalLocation?.iata || obj.arrivalLocation
    //   return true;
    // })
      
    searchObj['currencyOverride'] = selectedCurrency || def.currencyCode;
    // return console.log("Search Request - ",searchObj);
    // setData(newData);

    let enc = encrypt(JSON.stringify(searchObj));

            // SET TIME ------
    dispatch(setBookingData({...bookingData}))

    // setTimeout(() => {
    //   dispatch(setModal(true))
    //   dispatch(setModalComp(PriceTimeout))
    // },priceTimeout)

    // console.log(" -------------   ")
    // console.log(" -------------   ")
    // console.log('here: ',searchObj)
    // console.log(" -------------   ")
    // console.log(" -------------   ")
    let referralCode = searchParam.get('refCode');


    if(newWindow)
      window.open(`/search/flight/offers?referralCode=${referralCode}&q=${enc}`);
    else
      navigate(`/search/flight/offers?referralCode=${referralCode}&q=${enc}`);

  }

  let totalPassengers = Object.values(qObj?.passengers || {})?.reduce((p,c) => parseInt(p)+parseInt(c),[0]) || 0;
  const [hideClass,setHideClass] = useState(gotQ ? 'h-0-animate' : '');

  return (
    <div className={gotQ && `relative bg-secondary rounded-md px-4 mb-8` }>
      <div className={`py-5 !z-20 flex flex-col gap-4 relative overflow-hidden h-full-animate delay-500 max-h-[500px] ${hideClass} `}>
        <div className='flex flex-wrap-reverse items-center gap-4'>
          <div className='flex tabs flex-1'>
            <button onClick={() => setType(1)} className={type === 1 ? 'active' : ''}>One-Way</button>
            <button onClick={() => setType(2)} className={type === 2 ? 'active' : ''}>Round trip</button>
            <button onClick={() => setType(3)} className={type === 3 ? 'active' : ''}>Multi Destination</button>
          </div>

          <div className='flex gap-4 flex-1'>
            <TextField value={travelClass} onChange={(ev) => setTravelClass(ev.target.value)} className='min-w-[100px]'
              select label="Travel Class" size='small'>
              <MenuItem value='ECONOMY'>Economy</MenuItem>
              <MenuItem value="ECONOMY_STANDARD">Standard Economy</MenuItem>
              <MenuItem value="ECONOMY_PREMIUM">Premium Economy</MenuItem>
              <MenuItem value="BUSINESS">Business</MenuItem>
              <MenuItem value="FIRST_SUPERSONIC">First Class</MenuItem>
            </TextField>
            <TravelInfo q={qObj} returnPassenger={handleSetPassengers} />
          </div>

          <AirlinesInput val={airline} returnData={(val) => setAirline(val ? val.id : null)} label='Prefered Airline' size='small' />
        </div>
        {
          (type === 1) ?
            <OneWayInput handleSearch={handleSearch} q={qObj} />
          :
          (type === 2) ? 
            <RoundTripInput handleSearch={handleSearch} q={qObj} />
          :
          (type >= 3) ? 
            <MultiRouteInput handleSearch={handleSearch} q={qObj} />
          : null
        }
        <div className='flex gap-6 pb-3'>
          <label className='flex gap-2 items-center cursor-pointer'>
            <input type='checkbox' defaultChecked={noStops} onChange={(ev) => setNoStops(ev.target.checked)} />
            No stops
          </label>
          <TextField select size='small' value={flightType} onChange={(ev) => setFlightType(ev.target.value)} label='Flight Type'>
            <MenuItem value={'Any'} className='capitalize'>Any</MenuItem>
            {FLIGHT_TYPES.map((val,i) => (
              <MenuItem value={val} key={i} className='capitalize'>{val.toLowerCase()}</MenuItem>
            ))}
          </TextField>
          <TextField label='Deal Code'
            InputLabelProps={{
              shrink: true
            }}
            size='small' value={corporateUniFares} onChange={(ev) => setCorporateUniFares(ev.target.value)} />

          {/* <TextField select value={selectedCurrency} label='Currency' size='small'
            onChange={(ev) => setSelectedCurrency(ev.target.value)}
          >
            <MenuItem value='NGN'>NGN</MenuItem>
            <MenuItem value='USD'>USD</MenuItem>
          </TextField> */}
        </div>
        {/* {gotQ ? 
          <button className='border border-primary px-2 py-1 !rounded-md self-end' onClick={() => setHideBar(true)}>Hide Search</button>
        :null} */}
      </div>
      {gotQ?
      <button className={`flex gap-4 items-center border-t-0 text-primary top-full  h-full-animate absolute`} 
      onClick={() => setHideClass(hideClass ? '':'h-0-animate')}
      >
        <div className='bg-secondary rounded-b-md rounded-top-0 px-3 py-1 flex'>
          <Close className={`${hideClass?'rotate-45 mr-2':''} text-base transition-all`} />
          <span className={`${!hideClass?'max-w-0 px-0':'max-w-[100px]'} transition-all whitespace-nowrap overflow-hidden`}>Edit Search</span>
        </div>
        <div className={`${hideClass?'animate-fadeIn':'opacity-0'} duration-500  gap-6 overflow-hidden flex justify-end items-center text-primary delay-[1.5s] whitespace-nowrap `}>
          {qObj?.destinations?.length > 0 ? 
            <span className='flex gap-4 items-center'>
              <h3 className='flex gap-2 items-center'>
                {qObj?.destinations?.at(0)?.departureLocation?.city || qObj?.destinations?.at(0)?.departureLocation} 
                {qObj?.destinations?.map((dest,i) => (
                  <div key={i} className='flex gap-2 items-center'>
                    <span><Icon icon='ic:round-flight' className='rotate-90' /></span>
                    {dest?.arrivalLocation?.city || dest?.arrivalLocation}
                  </div>
                ))}
              </h3>
            </span>
          : null}

          {totalPassengers ? <span className='flex gap-2 items-center'>{`${totalPassengers} passenger`}</span>:''}
        </div>
      </button>
      :null}

    </div>
  ) 
  // : (
  //   <div className='py-2 flex justify-end items-center text-theme1 gap-6'>
  //     {totalPassengers ? <span className='flex gap-2 items-center'>{`${totalPassengers} passenger`}</span>:''}

  //     {qObj?.destinations?.length > 0 ? 
  //       <span className='flex gap-4 items-center'>
  //         <h3 className='flex gap-2'>
  //           {qObj?.destinations?.at(0)?.departureLocation} 
  //           <span>-</span>
  //           {qObj?.destinations?.at(-1)?.arrivalLocation}
  //         </h3>
  //         {/* {qObj?.destinations?.length > 1 ? 
  //           <h3 className='flex gap-2'>
  //             <span>...</span>
  //             {qObj?.destinations?.at(-1)?.departureLocation} 
  //             <span>-</span>
  //             {qObj?.destinations?.at(-1)?.arrivalLocation}
  //           </h3>
  //         : null} */}
  //       </span>
  //     : null}
  //     <button className='border-l pl-4 px-2 py-1 ' onClick={() => setHideBar(false)}>Edit Search</button>
  //   </div>
  // )
}

function TravelInfo({returnPassenger,returnBags,q}) {
  const [luggage,setLuggage] = useState();
  const [passenger,setPassenger] = useState() ;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const getPassenger = useMemo(() => {
    return q && Object.entries(q.passengers).map(([key,value]) => ({name: key,value}))
  },[q])

  useEffect(() => {
    setPassenger(getPassenger)
  },[getPassenger])

  // console.log('q be like: ',q)
  // console.log('passenger be like: ',passenger)
  // console.log('luggage be like: ',luggage)

  const handleReturnPassenger = useCallback((passenger) => {
    if(returnPassenger)
      returnPassenger(passenger.map((data) => (data.value >  0 && {[data.name]: data.value})).reduce((prev,cur) => ({...prev,...cur})));
  },[returnPassenger])

  useEffect(() => {
    if(Array.isArray(passenger))
      handleReturnPassenger(passenger)
  },[passenger,handleReturnPassenger])


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = open ? 'TravelInfo': undefined;

  return (
    <div>
    <Button
        aria-describedby={id}
        onClick={handleClick}
      >
      <div className='flex gap-2 self-start text-gray-700 cursor-pointer relative'>
        <div className='flex gap-1 items-center font-mono'>
          <Group />
          {passenger ? passenger.map(obj => obj.value).reduce((prev,cur) => parseInt(prev)+parseInt(cur),0) : 1}
        </div>
        {/* <div className='flex gap-1 items-center font-mono'>
          <Luggage />
          {luggage ? luggage.map(obj => obj.value).reduce((prev,cur) => prev+cur,0) : 0}
        </div> */}
      </div>
    </Button>
    <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        // TransitionComponent={Fade}
      >
        <Box className='flex flex-col gap-5 p-4 px-6 min-w-[300px]'>
          <TravelPassengers totalMax={9} returnData={(objs) => setPassenger(objs)} q={q && q.passengers} />
          {/* <TravelLuggage returnData={(objs) => setLuggage(objs)} /> */}
        </Box>
    </Popover>

    </div>
  )
}

function Loc({returnData,value}) {
  const [data,setData] = useState((value) || {departureLocation: "",arrivalLocation: ""});

  useEffect(() => {
    if(value)
      setData(value)
  },[value])

  function handleChange(val,obj) {
    if(!obj.iata) return false;

    setData(val)
    if(returnData)
      returnData(val);
  }

  function handleExchange(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    let depart = data.departureLocation;
    data.departureLocation = data.arrivalLocation;
    data.arrivalLocation = depart;
    setData(data);
    returnData && returnData(data);
  }
  return (
    <div className='flex gap-2 flex-1 justify-stretch relative'>
      <IataInput required display={['city']} className='flex-1 ' label="From" val={data.departureLocation} returnData={(val) => handleChange({...data,departureLocation: val},val)}
        icon={<Flight />}
      />
      <button onClick={handleExchange}
        className='flex items-center justify-center p-1 rounded-full bg-primary text-secondary self-center -mx-1 hover:rotate-180 transition-all'>
        <Icon icon='mdi:exchange' className='w-4 h-4' />
      </button>
      <IataInput required display={['city']} className='flex-1' label="To" val={data.arrivalLocation} returnData={(val) => handleChange({...data,arrivalLocation: val},val)} 
        icon={<Flight className='rotate-180' />}
      />
    </div>
  )
}
// function Persons({returnData}) {
//   const [data,setData] = useState((offerSearchTemp.passengers))

//   function handleChange(ev) {
//     console.log("p",data);
//     console.log("p",{...data,adults: ev.target.value});
//     setData({...data,adults: ev.target.value});
//     returnData({...data,adults: ev.target.value});
//   }
//   return (
//     <div>
//       <TextField select value={data.adults} label="How many persons" size='small' name='person'
//         onChange={handleChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position='start'>
//               <Avatar className='w-5 h-5 text-black' />
//             </InputAdornment>
//           )
//         }}
//       >
//         <MenuItem value={1}>1 Person</MenuItem>
//         <MenuItem value={2}>2 Person</MenuItem>
//       </TextField>
//     </div>
//   )
// }

function OneWayInput({handleSearch,q}) {
  const [data,setData] = useState(q || offerSearchTemp);
  const currentDate = moment().format('YYYY-MM-DD');
  const maxDate = moment().add(3, 'years').format('YYYY-MM-DD');

  useEffect(() => {
    if(q)
      setData(q)
  },[q])

  function setDate(ev) {
    let temp = clone(data);
    temp.destinations[0].date = ev.target.value;
    setData(temp);
  }
  function setLoc(val) {
    let temp = clone(data);
    temp.destinations[0] = {...temp.destinations[0],...val};
    setData(temp);
  } 
  return (
    <form onSubmit={(ev) => handleSearch(ev,data)} className='flex gap-2 '>

      <Loc returnData={setLoc} value={data.destinations[0]} />
      <TextField type='date' required label='Depart' size='small' name='date' className='w-[300px]'
        value={data.destinations[0].date}
        onChange={setDate}
        inputProps={{
          min: currentDate,
          max: maxDate
        }}
        InputLabelProps={{
          shrink: true,
        }}/>
      {/* <Persons returnData={(val) => setData({...data,passengers: val})} /> */}
      <button className='btn2 !rounded-sm'>Search</button>

    </form>

  )
}

// function getRoundDates(destinations) {
//   let dates = [null,null]
//   try {
//     destinations.map((d,i) => (dates[i] = moment(d.date)))
//   } catch(err) {

//   }
//   return dates;
// }

function RoundTripInput({handleSearch,q}) {
  const [data,setData] = useState(q || offerSearchTemp)

  const [disabledDate] = useState((current) => {
    // Disable dates before today
    return current && current < moment().startOf('day');
  });
  // useEffect(() => {
  //   if(q)
  //     setData(q)
  // },[q])
  // useEffect(() => {
  //   console.log(' --- round trip date range')
  //   console.log(getRoundDates())
  //   // console.log(data.destinations.map(d =>  (moment(d.date).isValid() ? moment(d.date) : "")))
  // },[data])

  // const roundDates = [moment("2023-6-16"),moment()]
  // const roundDates = useMemo(() => getRoundDates(data.destinations),[data.destinations])

  let date = data.destinations.map(d =>  (moment(d.date).isValid() ? moment(d.date) : null));
  // for(let i=2;i>date.length;i--) {
  //   date.push('')
  // }
  console.log('date to be : ',date)

  function handleChange(dates) {
    if(!Array.isArray(dates))
      return false;
    
    
    let temp = clone(data);
    temp.destinations[0].date = moment(dates[0].$d).format("YYYY-MM-DD");

    if(!dates[1]) dates[1] = "";
    
    temp.destinations[1] = {
      "departureLocation": data.destinations[0].arrivalLocation,
      "arrivalLocation": data.destinations[0].departureLocation,
      "date": moment(dates[1].$d).format("YYYY-MM-DD")
    };

    setData(temp);
  }
  function setLoc(val) {
    let temp = clone(data);
    temp.destinations[0] = {...temp.destinations[0],...val};
    setData(temp);
  } 
  return (
    
    <form onSubmit={(ev) => handleSearch(ev,data)} className='flex flex-wrap justify-stretch gap-2'>
      <Loc returnData={setLoc} value={data.destinations[0]} />
      <RangePicker disabledDate={disabledDate} placeholder={[data?.destinations?.at(0)?.date || "Departure Date",data?.destinations?.at(1)?.date || "Return Date"]} 
        // value={[moment('2023-06-16'),moment('2023-06-30')]}
        
        onChange={handleChange}
        />
        {/* // value={data.destinations.map(d =>  (moment(d.date).isValid() ? moment(d.date) : ""))} */}
      {/* <Persons returnData={(val) => setData({...data,passengers: val})} /> */}
      <div className='flex justify-end '>
        <button className='btn2 !rounded-sm '>Search</button>
      </div>
    </form>

  )
}

function MultiRouteInput({handleSearch,q}) {
  let fill = [clone(offerSearchTemp),clone(offerSearchTemp)];
  if(q) fill = q.destinations.map((d) => ({destinations: [d]}));
  
  const currentDate = moment().format('YYYY-MM-DD');
  const maxDate = moment().add(3, 'years').format('YYYY-MM-DD');

  const [data,setData] = useState(fill)

  useEffect(() => {
    if(q) {
      let fill = q.destinations.map((d) => ({destinations: [d]}));
      setData(fill)
    }
  },[q])


  function setDate(ev,i) {
    let temp = clone(data);
    temp[i].destinations[0].date = ev.target.value;
    setData(temp);
  }

  function setLoc(val,i) {
    let temp = clone(data);
    // console.log("check",temp);
    
    temp[i].destinations[0] = {...temp[i].destinations[0],...val};
    setData(temp);
  } 

  // function setPerson(val,i) {
  //   let temp = data;
  //   temp[i].passengers = val;
  //   setData(temp)
  // }

  function joinSearch(ev) {
    let build = clone(offerSearchTemp);
    build.destinations = data.map((obj) => obj.destinations[0])
    handleSearch(ev,build)
  }

  return (
    <form onSubmit={joinSearch} className='flex gap-2 flex-wrap'>
      <div className='flex flex-col gap-2 flex-1'>
      {
        data.map((d,i) => { return (
          <div key={i} className='flex justify-stretch flex-wrap gap-2 '>
            <Loc returnData={(val) => setLoc(val,i)} value={d.destinations[0]} />
            <TextField required type='date' label='Depart' size='small' className='w-[300px]'
              value={d.destinations[0].date}
              onChange={(ev) => setDate(ev,i)}
              inputProps={{
                min: currentDate,
                max: maxDate,
              }}
              InputLabelProps={{
                shrink: true,
              }}/>
            {/* <Persons returnData={(val,i) => setPerson(val,i)} /> */}
            {
              i>=2 ? (
                <Cancel onClick={() => setData(data => data.filter((d,k) => i !== k))} />
              ) : null
            }
            </div>
        )})
      }
      </div>
      <div className='flex flex-wrap self-end gap-2'>
        <button className='btn2 !rounded-sm' onClick={(ev) => {ev.preventDefault();setData(data => [...data,clone(offerSearchTemp)])}}>Add</button>
        <button className='btn2 !rounded-sm'>Search</button>
      </div>
    </form>

  )
}